import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom';

import { HelmetProvider } from 'react-helmet-async';

// Reset scroll cache and move to top on page reload / hard refresh
if (typeof window !== 'undefined') {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  const isReload =
    (window.performance &&
      performance.getEntriesByType &&
      performance.getEntriesByType('navigation')[0]?.type === 'reload') ||
    window.performance?.navigation?.type === 1;

  if (isReload) {
    try {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith('cg_scroll_') || key.startsWith('cg_last_game_id_')) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {}
    window.scrollTo(0, 0);
  }

  // Clear scroll restoration cache on full page refresh / unload
  window.addEventListener('beforeunload', () => {
    try {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith('cg_scroll_') || key.startsWith('cg_last_game_id_')) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {}
  });

  window.addEventListener('pagehide', () => {
    try {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith('cg_scroll_') || key.startsWith('cg_last_game_id_')) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {}
  });

  // On page load, if not restoring a route, ensure page is cleanly at top
  window.addEventListener('load', () => {
    const hasSavedScroll = Boolean(sessionStorage.getItem('cg_scroll_' + window.location.pathname));
    if (!hasSavedScroll) {
      window.scrollTo(0, 0);
      if (window.__lenis) {
        window.__lenis.scrollTo(0, { immediate: true, force: true });
      }
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ErrorBoundary>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// P18 – Register service worker for static-asset caching (stale-while-revalidate)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .catch((err) => console.error('SW registration failed:', err));
  });
}

